import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';


import Index from './components/Index';
import 'react-tooltip/dist/react-tooltip.css'
import { Provider, useDispatch } from 'react-redux';
import store from './store';

function App() {
  return (
    <>
      <Provider store={store}>
        <Index/>
      </Provider>
    </>
  );
}

export { App }
